import "./loading-indicator.css"
import {Color, getCssVar} from "@web-libs/features/colors/application/colors";

export const LoadingIndicator = ({color="primary", large, small}:{color?:Color, large?:boolean, small?:boolean}) => {

    const _color = getCssVar(color)

    const _class = `lds-ripple ${large ? "large" : ""} ${small ? "small" : ""}`

    return (
        <div style={{borderColor:_color}} className={_class}>
            <div style={{borderColor:_color}}></div>
            <div style={{borderColor:_color}}></div>
        </div>
    )
}
